<div class="static-generation-info-wrapper">
  <div class="static-generation-info">
    <h4>{{ textHeader }}</h4>
    <p>{{ textContent }}</p>
  </div>
</div>
